import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { Views, DefaultView } from '../../types/BlockWithViews';
import { TransformPageTypeDefaultView } from './views/TransformPageTypeDefaultView';
import { BlockType } from '../../types/api/ElementType';

type TransformPageTypeProps = Views<DefaultView<TransformPageTypeDefaultView>>;

function TransformPageType({ views }: TransformPageTypeProps) {
  return <TransformPageTypeDefaultView {...views.default} />;
}

export const TransformPageTypeBlock = asFetchableBlock(TransformPageType, BlockType.transformpagetype);
export type TransformPageTypeBlock = ComponentProps<typeof TransformPageTypeBlock>;
